import React from 'react';
import { Link } from 'react-router-dom';
import {
  ShoppingBagIcon,
  MagnifyingGlassIcon,
  HeartIcon,
  DocumentIcon,
  ExclamationTriangleIcon,
} from '@heroicons/react/24/outline';

const EmptyState = ({ 
  type = 'generic', 
  title, 
  description, 
  actionText,
  actionLink,
  onAction,
  icon: CustomIcon,
  className = ''
}) => {
  // Predefined empty states
  const presets = {
    products: {
      icon: ShoppingBagIcon,
      title: 'לא נמצאו מוצרים',
      description: 'נסה לשנות את הפילטרים או תנאי החיפוש שלך',
      actionText: 'צפה בכל המוצרים',
      actionLink: '/products',
    },
    search: {
      icon: MagnifyingGlassIcon,
      title: 'לא נמצאו תוצאות חיפוש',
      description: 'נסה מילות חיפוש אחרות או סנן לפי קטגוריות שונות',
      actionText: 'נקה חיפוש',
    },
    wishlist: {
      icon: HeartIcon,
      title: 'רשימת המשאלות שלך ריקה',
      description: 'התחל להוסיף מוצרים שאתה אוהב לרשימת המשאלות שלך',
      actionText: 'גלה מוצרים',
      actionLink: '/products',
    },
    cart: {
      icon: ShoppingBagIcon,
      title: 'העגלה שלך ריקה',
      description: 'נראה שעדיין לא הוספת מוצרים לעגלת הקניות שלך',
      actionText: 'התחל לקנות',
      actionLink: '/products',
    },
    orders: {
      icon: DocumentIcon,
      title: 'אין עדיין הזמנות',
      description: 'ברגע שתבצע הזמנה, היא תופיע כאן',
      actionText: 'התחל לקנות',
      actionLink: '/products',
    },
    error: {
      icon: ExclamationTriangleIcon,
      title: 'משהו השתבש',
      description: 'אנחנו מתנצלים, נסה שוב מאוחר יותר',
      actionText: 'נסה שנית',
    },
    generic: {
      icon: DocumentIcon,
      title: 'אין תוצאות להצגה',
      description: 'לא נמצאו נתונים להצגה כרגע',
    },
  };

  const preset = presets[type] || presets.generic;
  const Icon = CustomIcon || preset.icon;
  const finalTitle = title || preset.title;
  const finalDescription = description || preset.description;
  const finalActionText = actionText || preset.actionText;
  const finalActionLink = actionLink || preset.actionLink;

  return (
    <div className={`flex flex-col items-center justify-center py-12 sm:py-16 lg:py-20 px-4 ${className}`}>
      {/* Icon */}
      <div className="mb-6">
        <div className="inline-flex items-center justify-center w-16 h-16 sm:w-20 sm:h-20 bg-gray-100 rounded-full">
          <Icon className="w-8 h-8 sm:w-10 sm:h-10 text-gray-400" aria-hidden="true" />
        </div>
      </div>

      {/* Title */}
      <h3 className="text-lg sm:text-xl font-bold text-gray-900 mb-2 text-center">
        {finalTitle}
      </h3>

      {/* Description */}
      <p className="text-sm sm:text-base text-gray-600 mb-6 max-w-md text-center">
        {finalDescription}
      </p>

      {/* Action Button */}
      {(finalActionText || onAction) && (
        <div className="flex flex-col sm:flex-row gap-3">
          {finalActionLink ? (
            <Link
              to={finalActionLink}
              className="btn btn-primary px-6 py-3 text-sm sm:text-base touch-manipulation"
            >
              {finalActionText}
            </Link>
          ) : onAction ? (
            <button
              onClick={onAction}
              className="btn btn-primary px-6 py-3 text-sm sm:text-base touch-manipulation"
            >
              {finalActionText}
            </button>
          ) : null}
        </div>
      )}
    </div>
  );
};

export default EmptyState;

